import React, { useEffect, useState, useContext } from "react";
import NSMultiSelector from "../NSMultiSelector/NSMultiSelector";
import { isIPad13, isMobile } from "react-device-detect";
import { TimelineContext } from "../../helpers/Context";
import { OptionsCausaParada } from "../../helpers/Constants";
import { iconCausaParada } from "../../helpers/ImagesCache";
import useTranslation from "../../hooks/useTranslation";
import { FloatingDialog } from "../../components/atoms/FloatingDialog";
import SimpleButton from "../NSButton/Types/SimpleButton";

const DialogCausaParada = ({ callbackConfirm, callbackCancel, status }) => {
  const ctxTimeline = useContext(TimelineContext);
  const T = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [savedCausaH, setSavedCausaH] = useState([]);
  const [savedCausaT, setSavedCausaT] = useState([]);
  const [causaH, setCausaH] = useState(ctxTimeline.CausaH);
  const [causaT, setCausaT] = useState(ctxTimeline.CausaT);

  const arraysEqual = (a = [], b = []) =>
    a.length === b.length &&
    a.every((val) => b.includes(val)) &&
    b.every((val) => a.includes(val));

  const handlerClose = () => {
    setIsOpen(false);
    if (callbackCancel) {
      callbackCancel();
    }
  };

  const handlerSelect = () => {
    updateCausaHContext();
    updateCausaTContext();
    if (callbackConfirm) {
      setSavedCausaH(causaH);
      setSavedCausaT(causaT);
      callbackConfirm(causaH, causaT);
    }
  };

  const updateCausaHContext = () => {
    const actuales = [...ctxTimeline.CausaH];
    causaH?.map((item) => {
      const existe = actuales?.find((a) => a === item);
      if (existe) {
        ctxTimeline.CausaH = [...actuales?.filter((a) => a !== item)];
      } else {
        ctxTimeline.CausaH = [...actuales?.filter((a) => a !== item), item];
      }
    });
  };
  const updateCausaTContext = () => {
    const actuales = [...ctxTimeline.CausaT];
    causaT?.map((item) => {
      const existe = actuales?.find((a) => a == item);
      if (existe) {
        ctxTimeline.CausaT = [...actuales?.filter((a) => a !== item)];
      } else {
        ctxTimeline.CausaT = [...actuales?.filter((a) => a !== item), item];
      }
    });
  };

  useEffect(() => {
    setIsOpen(status);
  }, [status]);
  useEffect(() => {}, [causaH, causaT]);

  return (
    <>
      <FloatingDialog
        isOpen={isOpen}
        onClose={handlerClose}
        headerText={T("detectaCausasReversibles")}
        headerIcon={iconCausaParada}
        variant={"bottom"}
      >
        <div className="w-full">
          <div className="flex w-full  pb-[15px] flex-1 items-start  overflow-auto  ">
            <div className="text-sm flex flex-col w-full h-full items-start justify-start overflow-auto mr-1 ">
              <span
                style={{ fontSize: isMobile ? "18px" : "22px" }}
                className="font-bold pl-4 mb-5"
              >
                {"H"}
              </span>
              <NSMultiSelector
                options={OptionsCausaParada[0]}
                contexto={"causa-h"}
                onCallBack={(opt) => setCausaH(opt)}
                initial={causaH}
              />
            </div>
            <div className="text-sm  flex  flex-col w-full h-full items-start justify-start overflow-auto ml-1">
              <span
                style={{ fontSize: isMobile ? "18px" : "22px" }}
                className="font-bold pl-4 mb-5"
              >
                {"T"}
              </span>
              <NSMultiSelector
                options={OptionsCausaParada[1]}
                contexto={"causa-t"}
                onCallBack={(opt) => setCausaT(opt)}
                initial={causaT}
              />
            </div>
          </div>
          <div
            style={{
              marginBottom: isMobile ? "60px" : "0px",
              borderTop: "1px solid #e5e5e5",
            }}
            className=" flex pt-4 justify-center items-center w-full"
          >
            <SimpleButton
              disabled={
                arraysEqual(savedCausaH, causaH) &&
                arraysEqual(savedCausaT, causaT)
              }
              text={T("saveAndReturn")}
              onClick={handlerSelect}
            />
          </div>
        </div>
      </FloatingDialog>
    </>
  );
};

export default DialogCausaParada;

const styles = {
  saveContainer: {
    height: !isIPad13 ? "80px" : "80px",
    marginBottom: !isIPad13 ? "60px" : "30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    background: "white",
    overflow: "hidden",
    width: "100%",
  },
  saveButton: {
    background: "#2aac9cff",
    color: "white",
    fontWeight: "bold",
  },
};
